import { jsx as _jsx } from "react/jsx-runtime";
import { ReviewsImport } from './ReviewsImport';
var ReviewsImportPage = function (_a) {
    var params = _a.params;
    var shopId = params.id;
    return _jsx(ReviewsImport, { shopId: shopId });
};
export default ReviewsImportPage;
